module.exports = __webpack_public_path__ + "static/media/uae-logo.58a8c1e1.jpg";